"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepositoryTypes = void 0;
var RepositoryTypes;
(function (RepositoryTypes) {
    RepositoryTypes["CUSTOMER"] = "repository.customer";
    RepositoryTypes["VEHICLE"] = "repository.vehicle";
    RepositoryTypes["VALUATION"] = "repository.valuation";
    RepositoryTypes["TEMPLATE"] = "repository.template";
    RepositoryTypes["VEHICLE_OPTIONS"] = "repository.vehicleOptions";
    RepositoryTypes["ANSWERED_QUESTIONNAIRE"] = "repository.answered_questionnaire";
    RepositoryTypes["ANSWERED_DYNAMIC_QUESTIONNAIRE"] = "repository.answered_dynamic_questionnaire";
    RepositoryTypes["QUESTIONNAIRE"] = "repository.questionnaire";
    RepositoryTypes["QUESTIONNAIRE_WITH_VALUATION"] = "repository.questionnaire_with_valuation";
    RepositoryTypes["DYNAMIC_QUESTIONNAIRE_REPO"] = "repository.dynamic_questionnaire";
    RepositoryTypes["DEALER"] = "repository.dealer";
    RepositoryTypes["CONTACT_METHOD"] = "repository.contact_method";
})(RepositoryTypes = exports.RepositoryTypes || (exports.RepositoryTypes = {}));
